import { Component, OnInit } from '@angular/core';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { AppService } from 'src/app/app.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-welcome',
  imports: [MatIconModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
})
export class WelcomeComponent
  extends PageLayoutBaseComponent
  implements OnInit
{
  constructor(protected override appService: AppService) {
    super(appService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  goToProjectOverview(): void {
    this.appService.setPageIndex(1);
  }
}
